import {
  FormControl,
  InputAdornment,
  Select,
  MenuItem,
  Typography,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import React from "react";
import CustomInputLabel from "../customInputLabel";

const CustomSelect = ({
  icon = null,
  placeholder = "Urgency",
  value,
  isDisabled = false,
  children,
  onChange,
  InputWidth,
  label,
  ...props
}) => {
  // Extract label from children based on current value
  const getSelectedLabel = () => {
    const childArray = React.Children.toArray(children);
    const selectedChild = childArray.find(
      (child) => child?.props?.value === value
    );
    return selectedChild?.props?.children || placeholder;
  };

  return (
    <>
      {label && <CustomInputLabel label={label} />}
      <FormControl
        fullWidth
        sx={{
          backgroundColor: "#fff",
          borderRadius: "8px",
          border: "1px solid #eee",
          // boxShadow: " 0 4px 12px rgba(0, 0, 0, 0.06)",
          padding: "0",
          width: InputWidth,
          "&:hover": { borderColor: "#D1D5DB" },
          "& .MuiOutlinedInput-notchedOutline": { border: "none" },
        }}
      >
        <Select
          value={value}
          onChange={onChange}
          displayEmpty
          IconComponent={KeyboardArrowDownIcon}
          disabled={isDisabled}
          startAdornment={
            icon && <InputAdornment position="start">{icon}</InputAdornment>
          }
          renderValue={() => (
            <Typography
              variant="body2"
              color={value ? "textPrimary" : "textSecondary"}
            >
              {getSelectedLabel()}
            </Typography>
          )}
          sx={{
            paddingTop: "7px",
            paddingBottom: "7px",
            paddingLeft: "12px",
            paddingRight: "12px",
            height: "12px", // optionally adjust height if needed
            color: "#374151",

            "& .MuiSelect-select": {
              paddingTop: 0,
              paddingBottom: 0,
              minHeight: "14px",
            },
          }}
          {...props}
        >
          <MenuItem disabled value="">
            <span style={{ color: "#000", fontSize: "12px" }}>
              {placeholder}
            </span>
          </MenuItem>
          {React.Children.map(children, (child) =>
            React.cloneElement(child, {
              sx: {
                fontSize: "14px",
                "&:hover": {
                  backgroundColor: "#2563EB", // light blue on hover
                  color: "#fff",
                },
                "&.Mui-selected": {
                  backgroundColor: "#2563EB", // blue when selected
                  color: "#fff",
                  "&:hover": {
                    backgroundColor: "#2563EB",
                    color: "#fff", // darker blue on hover when selected
                  },
                },
              },
            })
          )}
        </Select>
      </FormControl>
    </>
  );
};

export default CustomSelect;
